// extracted by mini-css-extract-plugin
export default {"container":"s05_container__oxuxg","wrapper":"s05_wrapper__BNSmb","desc":"s05_desc__dKCFe","enable":"s05_enable__H9WA3","logo":"s05_logo__8F6Lx"};